import { useCallback } from 'react';
import { useMutation } from 'react-query';
import { useAxios } from '../context/AxiosContext';
import { downloadFileFromResponse } from '../utils/fileDownload';

export const loginBannerFiles: Record<string, string> = {
  guide: 'Teladoc Health Client Portal Guide.docx',
  information: 'Teladoc Health Client Portal Information.pdf'
};

export const useLoginBannerMutation = () => {
  const { authAxios } = useAxios();

  const getShowBanner = useCallback(async () => {
    const response = await authAxios.get('/banner');
    return response.data;
  }, [authAxios]);

  const dismissBanner = useCallback(async () => {
    const response = await authAxios.post('/banner/viewed');
    return response.data;
  }, [authAxios]);

  const getBannerFiles = useCallback(
    async (fileName) => {
      return await authAxios.get(`/banner/${fileName}`, {
        responseType: 'blob'
      });
    },
    [authAxios]
  );

  const downloadInformation = useCallback(
    async (e) => {
      const response = await getBannerFiles(loginBannerFiles.information);
      downloadFileFromResponse(response, loginBannerFiles.information);
    },
    [getBannerFiles]
  );

  const dismissBannerMutation = useMutation(dismissBanner).mutateAsync;
  const downloadInformationMutation = useMutation(downloadInformation).mutateAsync;
  const getShowBannerMutation = useMutation(getShowBanner).mutateAsync;
  return {
    dismissBanner: dismissBannerMutation,
    downloadInformation: downloadInformationMutation,
    getShowBanner: getShowBannerMutation
  };
};
